export default __webpack_public_path__ + "static/icon_1inch-a47068509c84dacdbdfa90aa07842b0e.svg";